import { useHotkeys } from "react-hotkeys-hook";
import { useAccount } from "@/hooks/useAccount";
import { useOpenAccountStore } from "@/stores/openAccountStore";

export const useOpenAccountHotkey = () => {
    const { data } = useAccount();
    const hasMultipleAccounts = (data?.delegators?.length ?? 0) > 1;
    const show = useOpenAccountStore((state) => state.show);

    useHotkeys(
        "cmd+o,ctrl+o",
        (e) => {
            e.preventDefault();
            show();
        },
        { enabled: hasMultipleAccounts, enableOnContentEditable: false },
        [],
    );
};
